import React from 'react';
import { Link } from 'react-router-dom';
import { AppBar, Toolbar, Button } from '@mui/material';
import { useThemeContext } from '../../theme/ThemeProvider';
import LanguageSwitcher from '../LanguageSwitcher/LanguageSwitcher';
import { useTranslation } from 'react-i18next';
import CheckIcon from '../Icons/CheckIcon';
import './NavBar.scss';

const Navbar: React.FC = () => {
  const { isDarkMode, toggleTheme } = useThemeContext();
  const { t } = useTranslation();

  return (
    <AppBar position="static" className="navbar" elevation={0}>
      <Toolbar className="navbar__toolbar">
        <Link to="/" className="navbar__logo-link">
          <CheckIcon className="navbar__logo" />
        </Link>
        <Button
          color="inherit"
          component={Link}
          to="/task-time-calculator"
          className="navbar__button"
        >
          {t('navbar.taskTimeCalculator')}
        </Button>
        <Button
          color="inherit"
          component={Link}
          to="/map"
          className="navbar__button"
        >
          {t('navbar.map')}
        </Button>
        <Button
          color="inherit"
          onClick={toggleTheme}
          className="navbar__button"
        >
          {isDarkMode ? t('navbar.lightMode') : t('navbar.darkMode')}
        </Button>
        <LanguageSwitcher />
      </Toolbar>
    </AppBar>
  );
};

export default Navbar;
